import { Injectable } from '@angular/core';
import { json } from '@angular-devkit/core';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { TableSorts, TableSort } from '../../components/datatable/types/sort.type';

@Injectable({
  providedIn: 'root'
})
export class TableStateService {
  constructor(private localStorageService: LocalStorageService) {
  }

  setSorts(stateId: string, subState: string, sorts: Array<TableSort>): void {
    let state = this.localStorageService.getItem<json.JsonObject>(stateId);
    state = state === null ? {} : state;
    if (subState === undefined) {
      (state as unknown as TableSorts).sorts = sorts;
      this.localStorageService.setItem(stateId, state);
    } else {
      if (state[subState] === undefined || state[subState] === null) {
        state[subState] = { sorts: undefined };
      }
      (state[subState] as unknown as TableSorts).sorts = sorts;
      this.localStorageService.setItem(stateId, state);
    }
  }

  getSorts(stateId: string, subState: string = undefined): Array<TableSort> {
    if (subState !== undefined) {
      return this.getSubState(stateId, subState);
    }
    return this.getState(stateId);
  }

  resetSort(stateId: string, subState: string = undefined): void {
    this.setSorts(stateId, subState, undefined);
  }

  private getState(stateId: string): Array<TableSort> {
    const state = this.localStorageService.getItem<json.JsonObject>(stateId);
    if (state !== null && state.sorts !== undefined && Array.isArray(state.sorts)) {
      return state.sorts as unknown as Array<TableSort>;
    }
    return undefined;
  }

  private getSubState(stateId: string, subState: string): Array<TableSort> {
    const state = this.localStorageService.getItem(stateId);
    if (state !== null && state[subState] !== undefined && state[subState] !== null
      && state[subState].sorts !== undefined && Array.isArray(state[subState].sorts)) {
      return state[subState].sorts;
    }
    return undefined;
  }
}
